<div class="relative inline-block">
  <mmscan-button [text]="true" [icon]="primeIcons.BELL" (buttonClick)="onNotificationClick()" />
  @if (unreadNotificationsCount() && unreadNotificationsCount() !== '0') {
    <span
      class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium min-w-5 z-50"
    >
      {{ unreadNotificationsCount() }}
    </span>
  }
</div>

<mmscan-drawer
  [visible]="visible()"
  [header]="'nav.notifications.title' | translate"
  (exit)="onDrawerClose($event)"
  (getData)="onDrawerShow()"
>
  <div class="flex flex-col h-full">
    <div class="flex items-center justify-between gap-2 mb-4">
      <div class="flex gap-2">
        @for (tab of severityTabs; track tab) {
          <mmscan-button
            [label]="'nav.notifications.severity.' + tab | translate"
            [outlined]="activeSeverityTab() !== tab"
            [severity]="activeSeverityTab() === tab ? 'primary' : 'secondary'"
            size="small"
            (click)="setActiveSeverity(tab)"
            [badge]="getSeverityCount(tab)"
          />
        }
      </div>
      @if (unreadNotificationsCount() && unreadNotificationsCount() !== '0') {
        <mmscan-button
          [label]="'nav.notifications.markAllAsRead' | translate"
          [icon]="primeIcons.CHECK"
          size="small"
          severity="secondary"
          [text]="true"
          (click)="markAllAsRead()"
        />
      }
    </div>

    <div class="flex flex-col flex-1 overflow-y-auto">
      @if (notifications().length === 0 && !notificationsLoading()) {
        <div class="notification-empty text-center py-8">
          <i [class]="primeIcons.INBOX" class="text-4xl mb-2"></i>
          <p>{{ 'nav.notifications.empty' | translate }}</p>
        </div>
      } @else {
        @for (notification of notifications(); track notification.id) {
          <div
            class="notification-row"
            [ngClass]="getSeverityConfig(notification.severity).stripeClass"
            [class.notification-row--unread]="!notification.readAt"
            role="button"
            tabindex="0"
            [attr.aria-label]="getNotificationTitle(notification)"
            (click)="onCardClick(notification)"
            (keydown.enter)="onCardClick(notification)"
            (keydown.space)="onCardClick(notification)"
          >
            <div class="flex items-start gap-2.5">
              <div class="flex flex-col gap-1 min-w-0 flex-1">
                <div class="flex items-baseline gap-2">
                  <span class="text-sm truncate" [class.font-semibold]="!notification.readAt">
                    {{ getNotificationTitle(notification) }}
                  </span>
                  <span class="notification-meta text-xs shrink-0 ml-auto">
                    {{ notification.createdAt | date: 'short' : undefined : localeId() }}
                  </span>
                </div>

                <p class="notification-message text-sm">
                  @if (isExpanded(notification.id)) {
                    {{ getNotificationText(notification) }}
                  } @else {
                    {{ getTruncatedMessage(notification) }}
                  }
                </p>

                <div class="notification-meta flex items-center gap-3 text-xs">
                  <span
                    class="notification-severity"
                    [ngClass]="getSeverityConfig(notification.severity).textClass"
                  >
                    {{ 'nav.notifications.severity.' + notification.severity.toLowerCase() | translate }}
                  </span>
                  @if (getResourceName(notification.resourceType); as resourceName) {
                    <span>{{ resourceName }}</span>
                  }
                  @if (getNotificationText(notification).length > 50) {
                    <button type="button" class="notification-action" (click)="toggleExpanded(notification.id, $event)">
                      {{
                        (isExpanded(notification.id) ? 'nav.notifications.showLess' : 'nav.notifications.showMore')
                          | translate
                      }}
                    </button>
                  }
                  @if (!notification.readAt) {
                    <button
                      type="button"
                      class="notification-action notification-action--hover ml-auto"
                      (click)="markAsReadExplicit(notification, $event)"
                    >
                      {{ 'nav.notifications.markAsRead' | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      }
      @if (notificationsLoading()) {
        <div class="flex flex-col gap-2 pt-3">
          <p-skeleton height="3rem" />
          <p-skeleton height="3rem" />
          <p-skeleton height="3rem" />
        </div>
      }

      @if (hasMoreNotifications() && !notificationsLoading() && notifications().length > 0) {
        <div class="notification-load-more flex justify-center py-3">
          <mmscan-button
            [label]="'nav.notifications.loadMore' | translate"
            [text]="true"
            severity="secondary"
            size="small"
            (click)="loadMore()"
          />
        </div>
      }
    </div>
  </div>
</mmscan-drawer>
